// import publicIp from 'public-ip'

// export const getClientIp = async () => publicIp.v4()

export const getClientIp = async () => {
  return 'ip-not-found'
}

//TODO fix this
